import React from 'react';
import './footer.css';
import video2 from '../../Assests/video(2).mp4';

const Footer = () => {
  return (
    <section className="footer">
      {/* Overlay for dimming */}
      <div className="overlay"></div>

      {/* Background video */}
      <div className="videoDiv">
        <video
          src={video2}
          loop
          autoPlay
          muted
          type="video/mp4"
          className="backgroundVideo"
        ></video>
      </div>

      {/* Text Content */}
      <div className="contentOverlay">
        <div className="textDiv">
          <span className="smallText">Travel With Us</span>
          <h1 className="homeTitle">Explore the World</h1>
          <p className="quote">"Adventure is worthwhile." - Aesop</p>

          {/* Email and Send Button */}
          <div className="emailContainer">
            <input
              type="email"
              placeholder="Enter your email"
              className="emailInput"
            />
            <button className="sendButton">
              <span>Send</span>
              <i className="icon">📩</i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
